import { ThemeOptions } from '@mui/material';

export const palette = {
  green: '#689f38',
  lightGreen: '#cddc39',

  blue: '#1976d2',
  lightYellow: 'rgba(255, 255, 192, 1)',

  pink: '#ff4081',
};

// export const defaultThemeOptions: ThemeOptions = {
//   palette: {
//     primary: {
//       main: palette.green,
//     },
//     secondary: {
//       main: palette.lightGreen,
//     },
//   },
// } as const;

// export const blueThemeOptions: ThemeOptions = {
//   palette: {
//     primary: {
//       main: palette.blue,
//     },
//     secondary: {
//       main: palette.lightYellow,
//     },
//   },
// } as const;

// export const pinkThemeOptions: ThemeOptions = {
//   palette: {
//     primary: {
//       main: palette.pink,
//     },
//     secondary: {
//       main: palette.lightGreen,
//     },
//   },
// } as const;
